'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var _InputText = require('./InputText');

var _InputText2 = _interopRequireDefault(_InputText);

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.ControlString',

  propTypes: {
    name: _react.PropTypes.string.isRequired,
    value: _react.PropTypes.string.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var value = _props.value;
    var onChange = _props.onChange;

    return _react2['default'].createElement(
      _Group2['default'],
      { name: name },
      _react2['default'].createElement(_InputText2['default'], { value: value, onChange: onChange })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/ControlString.js
// module id = 960
// module chunks = 0